/* eslint-disable */
import Swiper, { Navigation, Pagination, EffectFade, Autoplay } from 'swiper';

Swiper.use([Navigation, Pagination, EffectFade, Autoplay]);

export default {
  init() {
    $(window).load(() => {
      // $("#myVideo").show();

      //document.getElementById("myVideo").style.display = "block";

      // Top slider
      // new Swiper(".home-top-slider .top-slider-wrap .swiper-container", {
      //   effect: "fade",
      //   autoplay: {
      //     delay: 3000,
      //   },
      //   pagination: {
      //     el: ".home-top-slider .top-slider-wrap .swiper-pagination",
      //     clickable: true,
      //   },
      // });

      new Swiper('.additional-courses-swiper .swiper-container', {
        slidesPerView: 1.3,
        spaceBetween: 23,
        pagination: {
          el: '.additional-courses-swiper .swiper-pagination',
          clickable: true,
        },
        breakpoints: {
          1380: {
            slidesPerView: 3,
          },
          1110: {
            slidesPerView: 2.5,
          },
          630: {
            slidesPerView: 2,
            spaceBetween: 23,
          },
          0: {
            spaceBetween: 18,
          },
        },
      });
    });

    this._360();
    this._consultAction();
  },
  _consultAction() {
    $(window).on('scroll', function () {
      const scrollTop = $(this).scrollTop();
      const homeTopSlider = $('.home-top-slider');

      if (!homeTopSlider.length) {
        return;
      }

      if (
        scrollTop > homeTopSlider.height() &&
        !$('.free-consult-form').hasClass('fixed-home')
      ) {
        $('.page-consult-action').addClass('fixed-home');
        $('.free-consult-form').addClass('fixed-home');
      } else if (
        scrollTop <= homeTopSlider.height() &&
        $('.free-consult-form').hasClass('fixed-home')
      ) {
        $('.page-consult-action').removeClass('fixed-home');
        $('.free-consult-form').removeClass('fixed-home');
      }
    });
  },
  _360() {
    $(window).load(() => {
      $(
        '.home-360-questions .questions-wrap .question-item.force .question-answer'
      ).slideToggle(200, function () {
        $(this).removeClass('force');
      });
    });

    $('.home-360-questions .questions-wrap .question-item .question-title').on(
      'click',
      function () {
        const item = $(this).parent();

        $('.question-item')
          .not(item)
          .removeClass('active')
          .find('.question-answer')
          .slideUp(200);

        const circleClass = item.data('class');
        const circle = $('.home-360-circle svg');

        item.toggleClass('active');
        item.find('.question-answer').stop().slideToggle(200);

        if (item.hasClass('active')) {
          circle.removeClass();
          circle.addClass(circleClass);
        } else {
          circle.removeClass();
        }
      }
    );
  },
  finalize() {
    // JavaScript to be fired on the home page, after the init JS
  },
};



// WEBPACK FOOTER //
// ./scripts/routes/home.js